import addRoute from '@/router/add-route';

const CreditMemos = () => import('@/modules/credit-memos/credit-memos.vue');
const CreditMemoDetails = () => import('@/modules/credit-memos/credit-memo-details.vue');

const creditMemos = [
    addRoute({
        name: 'credit-memos',
        path: '/credit-memos',
        component: CreditMemos,
        root: {label: 'Invoices', name: 'invoices'},
    }),
    addRoute({
        name: 'credit-memo-details',
        path: '/credit-memos/:id',
        component: CreditMemoDetails,
        root: {label: 'Invoices', name: 'invoices'},
    }),
];

export default creditMemos;
